module.exports = __webpack_public_path__ + "img/member_icon.308b6ce8.svg";